import React from 'react';
import styled, { css } from 'styled-components';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CheckDecagramIcon from 'mdi-material-ui/CheckDecagram';

const FeaturedBadge = styled.div`
  border-radius: 0 0 0 4px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  position: absolute;
  padding: 8px;
  right: 0;
  top: 4px;
  color: #fff;
  background-color: #20d340;
  svg {
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
`;

const FeaturedCard = styled(({ featured, background, children, ...other }) => (
  <Card {...other}>
    <CardContent>
      {featured && (
        <FeaturedBadge>
          <CheckDecagramIcon /> Featured
        </FeaturedBadge>
      )}
      {children}
    </CardContent>
  </Card>
))`
  position: relative;
  margin-bottom: 36px;
  padding: 8px;
  background: ${props => props.background};
  ${props =>
    props.featured &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 4px 4px 0 0;
        display: block;
        height: 4px;
        width: 100%;
        background: linear-gradient(90deg, #00d1ed 0%, #20d340 100%);
      }
    `}
`;

export default FeaturedCard;
